<template>
  <batch-batch-list></batch-batch-list>
</template>
<script>
export default {

};
</script>